export default "__VITE_ASSET__D7cM0PZp__"